<template>
  <div class="tab">
    <div class="tab-item" @click="TabClick">
      <div :class="{ active: isActive }">
        <slot name="text"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    path: String,
  },
  data() {
    return {
      //isActive: false,
    };
  },
  computed: {
    isActive() {
      //在当前被激活的path里面对比当前路径
      return this.$route.path.indexOf(this.path) == false; //返回false
    },
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    TabClick() {
      this.$router.push(this.path);
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tab {
  padding: 0 0.26rem;
  .tab-item {
    text-align: center;
    cursor: pointer;
    .size {
      font-size: 0.16rem;
    }
  }
}

.active {
  padding-bottom: 0.1rem;
  border-bottom: 2px solid #336fd1;
}
</style>
